import mirrorCreator from 'mirror-creator';

export const actionTypes = mirrorCreator([
  'MY_PAGES_CREATE_FOLDER_PAGE_SUCCESS',
  'MY_PAGES_CREATE_PAGE_FAILURE',
  'MY_PAGES_CREATE_PAGE_SUCCESS',
  'MY_PAGES_DELETE_PAGE_FAILURE',
  'MY_PAGES_DELETE_PAGE_SUCCESS',
  'MY_PAGES_EDIT_DIRECT_LINK_MODAL_REQUEST_CLOSE',
  'MY_PAGES_INITIALIZE_FAILURE',
  'MY_PAGES_INITIALIZE_SUCCESS',
  'MY_PAGES_IS_FETCHING',
  'MY_PAGES_IS_SAVING',
  'MY_PAGES_UNMOUNT',
  'MY_PAGES_UPDATE_FOLDER_TITLE_SUCCESS',
  'MY_PAGES_UPDATE_FOLDER_TITLE_FAILURE',
  'MY_PAGES_UPDATE_DIRECT_LINK_PAGE_SUCCESS',
  'MY_PAGES_UPDATE_DIRECT_LINK_PAGE_FAILURE',
  'MY_PAGES_UPDATE_PAGE_FAILURE',
  'MY_PAGES_UPDATE_PAGE_SUCCESS',
]);
